import axios from "axios";
import { API } from "../../const";
import { normParam } from "@/tools";

const M_API = API + "/api";
const store = {
  namespaced: true,
  state: {
    instansi_aktif: null,
    instansi_id: null,
    permission: [],
    diklats: []
  },
  getters: {
    instansi_aktif(state) {
      return state.instansi_aktif;
    },
    permission(state) {
      return state.permission;
    },
    diklats(state) {
      return state.diklats;
    },
    instansi_id(state) {
      return state.instansi_id;
    }
  },
  mutations: {
    pilihInstansi(state, instansi_aktif) {
      state.instansi_aktif = instansi_aktif;
    },
    setInstansi(state, val) {
      state.instansi_aktif = val;
    },
    setInstansiId(state, val) {
      state.instansi_id = val;
    }
  },
  actions: {
    // eslint-disable-next-line
    get({ commit }, params) {
      return axios
        .get(`${M_API}/instansi${normParam(params)}`)
        .then(res => {
          commit("main/setTotalInstansi", res.data.total, {
            root: true
          });
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    sync(_, { instansi_id }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/sync`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getInstansi(_, params) {
      return axios
        .get(`${M_API}/organisasi${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getMoodle(_, params) {
      return axios
        .get(`${M_API}/moodles${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    getAll() {
      return axios
        .get(`${M_API}/instansi`)
        .then(res => {
          return res.data.data;
        })
        .catch(err => Promise.reject(err));
    },
    detail(_, id_instansi) {
      return axios
        .get(`${M_API}/instansi/${id_instansi}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    profil(_, instansi_id) {
      return axios.get(`${M_API}/instansi/${instansi_id}`).then(res => {
        return res.data;
      });
    },
    akses({ state }, instansi_id) {
      return axios.get(`${M_API}/instansi/${instansi_id}/akses`).then(res => {
        state.permission = res.data;
      });
    },
    // // eslint-disable-next-line
    // getDiklats({ state }, instansi_id) {
    //   return axios.get(`${M_API}/instansi/${instansi_id}/diklats`).then(res => {
    //     state.diklats = res.data;
    //   });
    // },

    switchInstansi({ state, commit, dispatch }, instansi_id) {
      // cek apakah perlu load ulang instansi
      if (state.instansi_id == instansi_id) {
        return state.instansi_aktif;
      } else {
        return dispatch("detail", instansi_id)
          .then(res => {
            // reject jika instansi tidak ditemukan
            if (res.id) {
              state.instansi_aktif = res;
              state.instansi_id = res.id;
              commit("main/noInstansi", false, {
                root: true
              });
            } else {
              commit("main/noInstansi", true, {
                root: true
              });
              return Promise.reject();
            }
          })
          .then(() => {
            return dispatch("akses", instansi_id);
          })
          .then(() => {
            return dispatch("diklat/getDiklats", instansi_id, { root: true });
          });
      }
    },

    form(_, obj) {
      if (obj.id) {
        return axios
          .put(`${M_API}/instansi/${obj.id}`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      } else {
        return axios
          .post(`${M_API}/instansi`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      }
    },
    drop(_, instansi_id) {
      return axios.delete(`${M_API}/instansi/${instansi_id}`).then(res => {
        return res.data;
      });
    }
  }
};

export default store;
